import { useState } from "react";
import { Bell, Plus } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { useFetch } from "@/hooks/useFetch";
import { spaceParams } from "@/lib/spaces";
import { Empty, Loading, PageHeader, PrimaryButton, Segmented } from "@/components/Bits";
import { ReminderItem } from "@/components/ReminderItem";
import { ReminderSearch, useReminderSearch } from "@/components/ReminderSearch";

const FILTERS = [
  { value: "pending", label: "Open" },
  { value: "done", label: "Done" },
  { value: "all", label: "All" },
];

export default function Reminders() {
  const { space, openAdd } = useApp();
  const [status, setStatus] = useState("pending");
  const items = useFetch("/reminders", { ...spaceParams(space), ...(status === "all" ? {} : { status }) });
  const s = useReminderSearch(items);

  return (
    <div data-testid="reminders-page">
      <PageHeader title="Reminders" subtitle="High emails every 15 min, Medium every hour, Low every 4 hours (9am–5pm) until you tick them off.">
        <Segmented options={FILTERS} value={status} onChange={setStatus} testid="reminders-filter" />
        <PrimaryButton onClick={() => openAdd("reminder")} data-testid="add-reminder-btn"><Plus className="h-4 w-4" /> New reminder</PrimaryButton>
      </PageHeader>
      <ReminderSearch {...s} aiEnabled={s.aiEnabled && status === "pending"} />
      {!items ? <Loading /> : s.shown.length === 0 ? (
        <Empty icon={Bell} text={s.q ? "Nothing matches that search." : status === "done" ? "Nothing completed yet." : "No reminders here yet."} testid="empty-reminders" />
      ) : (
        <div className="max-w-4xl space-y-3">
          {s.ai && <p className="text-xs font-semibold uppercase tracking-wider text-cyan-300" data-testid="ai-search-label">AI found {s.shown.length} match{s.shown.length === 1 ? "" : "es"}</p>}
          {s.shown.map((r) => (
            <div key={r.id}>
              {r.ai_why && <p className="mb-1 pl-1 text-xs text-cyan-200/80" data-testid={`ai-why-${r.id}`}>{r.ai_why}</p>}
              <ReminderItem r={r} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
